import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { Popover } from "@progress/kendo-react-tooltip";
import { FC, useRef, useState } from "react";

/**
 * `CellPopover` is a custom cell component for Kendo Grid that displays a popover
 * containing the full content of the cell when the cell's content is truncated (i.e., ellipsis is applied).
 *
 * Features:
 * - Detects if the cell content is truncated using the `scrollWidth` and `clientWidth` properties.
 * - Displays a popover when the user hovers over a truncated cell, showing the full text.
 *
 * Props:
 * @param {GridCustomCellProps} props - Props passed by Kendo Grid, including data and field information.
 */
const CellPopover: FC<GridCustomCellProps> = (props) => {
	const anchor = useRef<HTMLDivElement>(null);

	const [show, setShow] = useState(false);

	const isEllipsisActive = (): boolean => {
		if (anchor.current) {
			return anchor.current.scrollWidth > anchor.current.clientWidth;
		}
		return false;
	};

	const onHover = () => {
		if (!isEllipsisActive()) {
			return;
		}
		setShow(true);
	};

	return (
		<td
			style={
				{
					// whiteSpace: "nowrap",
					// textOverflow: "ellipsis",
					// overflow: "hidden",
				}
			}
			className={props.className}
			onMouseOver={() => onHover()}
			onMouseLeave={() => setShow(false)}
		>
			<div
				style={{
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					overflow: "hidden",
					width: "100%",
				}}
				ref={anchor}
			>
				{props.dataItem[props?.field as any]}
			</div>

			<Popover show={show} anchor={anchor.current} position={"bottom"}>
				{props.dataItem[props?.field as any]}
			</Popover>
		</td>
	);
};

export function CellPopoverWithText(
	props: GridCustomCellProps & { text: string }
) {
	const anchor = useRef<HTMLDivElement>(null);

	const [show, setShow] = useState(false);

	const isEllipsisActive = (): boolean => {
		if (anchor.current) {
			return anchor.current.scrollWidth > anchor.current.clientWidth;
		}
		return false;
	};

	const onHover = () => {
		if (!isEllipsisActive()) {
			return;
		}
		setShow(true);
	};

	return (
		<td
			style={
				{
					// whiteSpace: "nowrap",
					// textOverflow: "ellipsis",
					// overflow: "hidden",
				}
			}
			className={props.className}
			onMouseOver={() => onHover()}
			onMouseLeave={() => setShow(false)}
		>
			<div
				style={{
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					overflow: "hidden",
					width: "100%",
				}}
				ref={anchor}
			>
				{props.text}
			</div>

			<Popover show={show} anchor={anchor.current} position={"bottom"}>
				{props.text}
			</Popover>
		</td>
	);
}

export default CellPopover;
